// script-loader.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {
  private loadedScripts = new Map<string, Promise<void>>();

  public loadScript(src: string): Promise<void> {
    // Return the existing promise if script is already being loaded or loaded
    if (this.loadedScripts.has(src)) {
      return this.loadedScripts.get(src)!;
    }

    // Create a new promise and load script
    const promise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script ${src}`));
      document.body.appendChild(script);
    });

    this.loadedScripts.set(src, promise);
    return promise;
  }
}
